import { render, staticRenderFns } from "./TalkDialog.vue?vue&type=template&id=ed5d3bae&scoped=true&"
import script from "./TalkDialog.vue?vue&type=script&lang=js&"
export * from "./TalkDialog.vue?vue&type=script&lang=js&"
import style0 from "./TalkDialog.vue?vue&type=style&index=0&id=ed5d3bae&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed5d3bae",
  null
  
)

export default component.exports